/**
 * 格式化工具函数
 */

/**
 * 格式化日期
 * @param {Date|string} date 日期对象或字符串
 * @param {string} format 格式化字符串
 * @returns {string} 格式化后的日期字符串
 */
export const formatDate = (date, format = 'YYYY-MM-DD') => {
  if (!date) return '';
  
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
};

/**
 * 格式化浏览次数
 * @param {number} count 浏览次数
 * @returns {string} 格式化后的浏览次数
 */
export const formatViewCount = (count) => {
  if (count === undefined || count === null) return '0';
  
  const num = Number(count);
  if (isNaN(num)) return '0';
  
  if (num < 1000) {
    return num.toString();
  } else if (num < 10000) {
    return (num / 1000).toFixed(1) + 'K';
  } else if (num < 100000) {
    return Math.floor(num / 1000) + 'K';
  } else if (num < 1000000) {
    return Math.floor(num / 10000) + 'W';
  } else {
    return (num / 1000000).toFixed(1) + 'M';
  }
};

/**
 * 格式化价格
 * @param {number} price 价格
 * @param {string} currency 货币符号
 * @returns {string} 格式化后的价格
 */
export const formatPrice = (price, currency = '¥') => {
  if (price === undefined || price === null) return '';
  
  const num = Number(price);
  if (isNaN(num)) return '';
  
  return `${currency}${num.toLocaleString()}`;
};

/**
 * 格式化文件大小
 * @param {number} size 文件大小（字节）
 * @returns {string} 格式化后的文件大小
 */
export const formatFileSize = (size) => {
  if (size === undefined || size === null) return '';
  
  const num = Number(size);
  if (isNaN(num) || num < 0) return '';
  
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let unitIndex = 0;
  let fileSize = num;
  
  while (fileSize >= 1024 && unitIndex < units.length - 1) {
    fileSize /= 1024;
    unitIndex++;
  }
  
  return `${fileSize.toFixed(1)}${units[unitIndex]}`;
};

/**
 * 截断文本
 * @param {string} text 原文本
 * @param {number} maxLength 最大长度
 * @param {string} suffix 后缀
 * @returns {string} 截断后的文本
 */
export const truncateText = (text, maxLength = 100, suffix = '...') => {
  if (!text || typeof text !== 'string') return '';
  
  if (text.length <= maxLength) return text;
  
  return text.substring(0, maxLength) + suffix;
};

/**
 * 格式化电话号码
 * @param {string} phone 电话号码
 * @returns {string} 格式化后的电话号码
 */
export const formatPhone = (phone) => {
  if (!phone) return '';
  
  // 移除所有非数字字符
  const numbers = phone.replace(/\D/g, '');
  
  // 根据号码长度格式化
  if (numbers.length === 11) {
    // 手机号码格式：138-1234-5678
    return numbers.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  } else if (numbers.length === 10) {
    // 固定电话格式：010-1234567
    return numbers.replace(/(\d{3})(\d{7})/, '$1-$2');
  } else if (numbers.length === 8) {
    // 固定电话格式：1234-5678
    return numbers.replace(/(\d{4})(\d{4})/, '$1-$2');
  }
  
  return phone; // 保持原格式
}; 